<div class="input-group">
  <input class="form-control m-0" placeholder="{{ placeholder || 'yyyy-mm-dd' }}" name="dp" [ngModel]="model"
    (ngModelChange)="modelChanged($event)" ngbDatepicker #datepicker="ngbDatepicker" [disabled]="disabled" #datepickerInput
    [markDisabled]="markDisabledFunction" [outsideDays]="showOtherMonthDays" [firstDayOfWeek]="7">
  <div class="input-group-append">
    <button class="btn btn-outline-input-group" (click)="datepicker.toggle()" type="button" [disabled]="disabled">
      <i class="fas fa-calendar"></i>
    </button>
  </div>
</div>

